import { render } from "./Popup.vue?vue&type=template&id=0aad0588"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=0aad0588&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__